<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <h3>
        <i class="fa fa-check-circle"></i> Processed LawPay Payments
        <button class="btn btn-sm btn-outline-secondary float-right" (click)="refresh()" [disabled]="loading">
          <i class="fa fa-refresh" [class.fa-spin]="loading"></i> Refresh
        </button>
      </h3>
      <p class="text-muted">Payments that have been processed into receipts</p>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <strong>Processed Payments</strong>
          <span class="badge badge-secondary float-right">{{ totalCount }}</span>
        </div>
        <div class="card-body p-0">
          <div *ngIf="loading" class="text-center p-4">
            <i class="fa fa-spinner fa-spin fa-2x"></i>
            <p>Loading payments...</p>
          </div>

          <div *ngIf="!loading && payments.length === 0" class="text-center p-4 text-muted">
            <i class="fa fa-inbox fa-3x mb-2"></i>
            <p>No processed payments found</p>
          </div>

          <table *ngIf="!loading && payments.length > 0" class="table table-hover table-sm mb-0">
            <thead>
              <tr>
                <th>Date</th>
                <th>Payer</th>
                <th class="text-right">Amount</th>
                <th>Payment Method</th>
                <th>Status</th>
                <th>Processed</th>
                <th class="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let payment of payments" [class.refund-reversal-row]="isRefundOrReversal(payment)">
                <td>{{ formatDate(payment.created_at) }}</td>
                <td>
                  <strong>{{ payment.payer_name || 'Unknown' }}</strong>
                  <br *ngIf="payment.payer_email">
                  <small class="text-muted">{{ payment.payer_email }}</small>
                </td>
                <td class="text-right" [class.refund-reversal-amount]="isRefundOrReversal(payment)">
                  <strong>{{ payment.formatted_amount }}</strong>
                  <span *ngIf="payment.is_refunded" class="text-danger">
                    <br><small>(Refunded)</small>
                  </span>
                  <span *ngIf="payment.refund_pending" class="text-info">
                    <br><small>(Refund pending)</small>
                  </span>
                  <span *ngIf="payment.refund_failed" class="text-warning">
                    <br><small>(Refund failed)</small>
                  </span>
                </td>
                <td>
                  <span *ngIf="payment.card_brand">
                    {{ payment.card_brand | titlecase }} *{{ payment.card_last_four }}
                  </span>
                  <span *ngIf="!payment.card_brand">
                    {{ payment.payment_method_type | titlecase }}
                  </span>
                </td>
                <td>
                  <span class="badge" [ngClass]="getStatusBadgeClass(payment)">
                    {{ getStatusText(payment) }}
                  </span>
                </td>
                <td>
                  <small>{{ formatDate(payment.processed_at) }}</small>
                </td>
                <td class="text-center">
                  <button class="btn btn-sm btn-outline-primary mr-1"
                          (click)="viewReceipt(payment)"
                          *ngIf="payment.receipt_id"
                          title="View Receipt">
                    <i class="fa fa-file-text-o"></i>
                  </button>
                  <button class="btn btn-sm btn-outline-secondary mr-1"
                          (click)="viewEntryGroup(payment)"
                          *ngIf="payment.entry_group_id"
                          title="View LawPay Entry Group">
                    <i class="fa fa-sitemap"></i>
                  </button>
                  <button class="btn btn-sm btn-outline-danger"
                          (click)="openRefundModal(payment)"
                          *ngIf="canRefund(payment)"
                          title="Refund">
                    <i class="fa fa-undo"></i> Refund
                  </button>
                  <span *ngIf="payment.is_refunded" class="text-muted">
                    <small>Refunded {{ formatDate(payment.refunded_at) }}</small>
                  </span>
                  <span *ngIf="payment.refund_pending" class="text-muted">
                    <small>Waiting for LawPay callback</small>
                  </span>
                  <span *ngIf="payment.refund_failed" class="text-warning">
                    <small>{{ payment.refund_failure_reason || 'Refund failed' }}</small>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer" *ngIf="totalPages > 1">
          <pagination
            [totalItems]="totalCount"
            [itemsPerPage]="perPage"
            [(ngModel)]="currentPage"
            (pageChanged)="pageChanged($event)"
            [boundaryLinks]="true"
            [maxSize]="5"
            previousText="&lsaquo;"
            nextText="&rsaquo;"
            firstText="&laquo;"
            lastText="&raquo;">
          </pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Refund Modal -->
<div class="modal fade" [class.show]="showRefundModal" [style.display]="showRefundModal ? 'block' : 'none'" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header bg-danger text-white">
        <h5 class="modal-title">
          <i class="fa fa-undo"></i> Process Refund
        </h5>
        <button type="button" class="close text-white" (click)="closeRefundModal()">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="selectedPayment">
        <div class="alert alert-warning">
          <i class="fa fa-exclamation-triangle"></i>
          This submits a refund to LawPay. V7 records the bookkeeping only after LawPay sends the refund callback.
        </div>

        <div class="form-group">
          <label><strong>Payment Details</strong></label>
          <p class="mb-1">Payer: {{ selectedPayment.payer_name }}</p>
          <p class="mb-1">Original Amount: {{ selectedPayment.formatted_amount }}</p>
          <p class="mb-0">Transaction: {{ selectedPayment.lawpay_transaction_id }}</p>
        </div>

        <hr>

        <div class="form-group">
          <label for="refundAmount">Refund Amount</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">$</span>
            </div>
            <input type="number"
                   class="form-control"
                   id="refundAmount"
                   [(ngModel)]="refundAmount"
                   (ngModelChange)="loadRefundPreview()"
                   [max]="selectedPayment.amount"
                   min="0.01"
                   step="0.01">
          </div>
          <small class="text-muted">Maximum: {{ selectedPayment.formatted_amount }}</small>
        </div>

        <div class="form-group" *ngIf="loadingPreview">
          <small class="text-muted"><i class="fa fa-spinner fa-spin"></i> Calculating allocation…</small>
        </div>

        <div class="form-group" *ngIf="refundPreview && !loadingPreview">
          <label><strong>Allocation Preview (LIFO)</strong></label>
          <table class="table table-sm table-bordered mb-1">
            <thead class="thead-light">
              <tr>
                <th>Original Bill</th>
                <th class="text-right">Paid</th>
                <th class="text-right">Already Refunded</th>
                <th class="text-right">Will Refund</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let a of refundPreview.allocations" [class.text-muted]="a.will_refund == 0">
                <td>{{ a.paid_bill_summary }}</td>
                <td class="text-right">{{ a.original_amount | currency }}</td>
                <td class="text-right">{{ a.already_refunded | currency }}</td>
                <td class="text-right"><strong>{{ a.will_refund | currency }}</strong></td>
              </tr>
              <tr *ngIf="refundPreview.allocations.length === 0">
                <td colspan="4" class="text-muted text-center">No payment bills found — refund will be unallocated.</td>
              </tr>
            </tbody>
          </table>
          <small class="text-warning" *ngIf="refundPreview.note">{{ refundPreview.note }}</small>
        </div>

        <div class="form-group">
          <label for="refundReason">Reason for Refund</label>
          <textarea class="form-control"
                    id="refundReason"
                    [(ngModel)]="refundReason"
                    rows="3"
                    placeholder="Enter reason for refund..."></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeRefundModal()" [disabled]="refunding">
          Cancel
        </button>
        <button type="button" class="btn btn-danger" (click)="confirmRefund()" [disabled]="refunding">
          <i class="fa fa-undo" *ngIf="!refunding"></i>
          <i class="fa fa-spinner fa-spin" *ngIf="refunding"></i>
          Process Refund
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade show" *ngIf="showRefundModal"></div>
